import { Box } from "@mui/material";

interface CategoryBadgeProps {
  category: string;
}

export const CategoryBadge = ({ category }: CategoryBadgeProps) => {
  return (
    <Box
      sx={{
        backgroundColor: "grey.200",
        color: "text.secondary",
        borderRadius: 1,
        px: 1,
        py: 0.5,
        fontSize: "0.75rem",
      }}
    >
      {category}
    </Box>
  );
};
